<template>
  <div class="review-attachment-slider">
    <Swiper
      :modules="[SwiperNavigation, SwiperPagination]"
      :slides-per-view="1"
      :loop="!withoutLoop"
      :grab-cursor="true"
      :space-between="16"
      :navigation="{
        nextEl: '.review-attachments__btn-next',
        prevEl: '.review-attachments__btn-prev',
      }"
      :pagination="{
        el: '.swiper-pagination',
        clickable: true,
      }"
      :initial-slide="initialSlide"
      @slide-change="onChangeSlide"
      @click="onSwipeClick"
    >
      <SwiperSlide
        v-for="(attachment, index) in attachments"
        :key="index"
        class="review-attachment-slider__item"
        :lazy="true"
      >
        <img
          v-if="attachment.url"
          class="review-attachment-slider__image"
          :src="attachment.url"
          :alt="`review photo ${index + 1}`"
          loading="lazy"
        />
        <YoutubePlayer
          v-if="attachment.youtubeVideoId"
          ref="youtubePlayerRef"
          class="review-attachment-slider__video"
          :trigger="'visible'"
          :video-id="attachment.youtubeVideoId"
          :height="400"
          :width="580"
          :border-radius="16"
        />
      </SwiperSlide>
      <div class="swiper-pagination pagination-slider" />
      <CarouselNavigation class-name="review-attachments" />
    </Swiper>
  </div>
</template>

<script setup>
import CarouselNavigation from "~/modules/shared/sliders/ui/CarouselNavigation.vue";
import YoutubePlayer from "~/modules/shared/youtubePlayer/YoutubePlayer.vue";

const emits = defineEmits(["onChangeReview"]);

const props = defineProps({
  attachments: { type: Array, required: true },
  withoutLoop: { type: Boolean, required: false, default: false },
  initialSlide: { type: Number, required: false, default: 0 },
  reviewId: { type: String, required: true, default: "" },
});

const youtubePlayerRef = ref(null);
const currentSwipeIndex = ref(0);
const currentYTPlayerRef = computed(() => {
  const swipeVideoId =
    props.attachments[currentSwipeIndex.value].youtubeVideoId;

  return youtubePlayerRef.value?.find(
    ({ videoId }) => videoId === swipeVideoId,
  );
});

const onChangeSlide = (swiper) => {
  const { realIndex } = swiper;

  currentYTPlayerRef.value?.stopYTVideo();
  currentSwipeIndex.value = realIndex;

  if (props.reviewId !== props.attachments[realIndex].reviewId) {
    emits("onChangeReview", props.attachments[realIndex].reviewId);
  }
};

const onSwipeClick = () => {
  currentYTPlayerRef.value?.playYTVideo();
};
</script>

<style scoped lang="scss">
.review-attachment-slider {
  width: 100%;

  min-width: 0;
  min-height: 0;

  & > div {
    height: 100%;
  }

  &__image {
    width: 100%;
    height: 100%;

    border-radius: 16px;

    aspect-ratio: 16 / 9;
    object-fit: contain;
  }

  &__video {
    pointer-events: none;
  }
}
</style>
